<script>
    import { onMount } from "svelte";

    import { isMobile } from "../../stores";

    import { fly } from "svelte/transition";

    import {
        SearchInput,
        SearchSelect,
        SvelteTable,
        PageLoading,
        ResetFilterLink,
        TableElementPatientName,
    } from "../../Components/Common/index.svelte";

    import { apiMethods } from "../../Services/index.svelte";

import {
        decodeSearchParams,
        encodeSearchParams,
        getFormatBirthDate,
        getInsuranceType,
        getText,
        getTitle,
        goToURL,
        replaceURL,
        showError,
    } from "../../Utils/utilFunctions.svelte";
    import { BillingStatus, encounterStatus } from "../../Utils/utilEnums.svelte";

    import TableFooter from "../../Components/Layout/Table/TableFooter.svelte";
    import DoctorMultiSearchSelect from "../../Components/Common/DoctorMultiSearchSelect.svelte";

    export let params = {};

    let isGettingPatients = false,
        returnPatientArr = [],
        filters = {
            includeArchived: false,
            encounterBillingStatus: "0,1,2,3,4",
            encounterStatus: "0",
            badDebtor: Number(-1),
        },
        page = 0,
        pageSize = 25,
        count,
        checkboxString = "",
        selectedPatients = [],
        showFilters = false,
        selectedPatientsIdArr = [];

    let refreshDateInputValue;
    let selectedDoctors = [];

    const columns = [
        {
            key: "selected?",
            title: "",
            headerClass: "toggleSelectAllHeader text-center ml-3 rounded-tl-xl",
            renderValue: (v) =>
                `<input type="checkbox" class="checkbox checkbox-primary checkbox-xs ml-3 text-white cursor-pointer" name="selectCheckBox" id="selectCheckBoxId${v.id}">`,
            csvExportHidden: true,
        },
        {
            key: "id",
            title: "Patient ID",
            headerClass: "text-left pl-3 sortable-header-decoration",
            class: "px-3 cursor-pointer text-left",
            renderValue: (v) => getText(v.id),
        },
        {
            key: "name",
            title: "Patient name",
            headerClass: "text-left pl-3 sortable-header-decoration w-1/8",
            class: "px-3 cursor-pointer w-1/8 text-left",
            renderComponent: {
                component: TableElementPatientName,
                props: {
                    onFinish: () =>
                        loadPatients(
                            page * pageSize,
                            pageSize,
                            _getSearchParams(),
                        ),
                    clickTo: `/Patient/view`,
                },
            },
            csvContent: (v) => _getName(v),
        },
        {
            key: "gender",
            title: "Gender",
            headerClass: "text-left pl-3 cursor-default",
            class: "px-3 cursor-pointer text-left",
            renderValue: (v) => _getGender(v.sex),
        },
        {
            key: "dateOfBirth",
            title: "Date of Birth",
            headerClass: "text-left pl-3 cursor-default",
            class: "px-3 cursor-pointer text-left",
            renderValue: (v) => getFormatBirthDate(v.birthDate),
        },
        {
            key: "phone",
            title: "Phone No.",
            headerClass: "text-left pl-3 cursor-default",
            class: "px-3 cursor-pointer text-left",
            value: (v) => v.phone,
        },
        {
            key: "email",
            title: "Email",
            headerClass: "text-left pl-3 cursor-default",
            class: "px-3 cursor-pointer text-left",
            value: (v) => v.email,
        },
        {
            key: "insurance",
            title: "Insurance type",
            headerClass: "text-left pl-3 cursor-default rounded-tr-xl",
            class: "px-3 cursor-pointer text-left",
            renderValue: (v) => getInsuranceType(v.insuranceType),
        },
    ];

    const sortableHeaderKeys = ["id", "name"];

    $: _getCheckboxString(selectedPatientsIdArr);
    $: if (selectedPatients.length >= 0 && returnPatientArr.length > 0) {
        selectedPatientsIdArr = selectedPatients.map((patient) => patient.id);
        _updateHeaderIcon();
    }

    onMount(async () => {
        if (params.query) await updateSearchParamsByQuery(params.query);

        await loadPatients(page * pageSize, pageSize, _getSearchParams());

        if (params.query) updateCheckboxByQuery(params.query);
    });

    const updateSearchParamsByQuery = (query) => {
        const arr = decodeSearchParams(query).split("&");

        if (arr.length) {
            for (let i = 0; i < arr.length; i++) {
                if (arr[i].includes("page="))
                    page = Number(arr[i].split("=")[1]);

                if (arr[i].includes("size="))
                    pageSize = Number(arr[i].split("=")[1]);

                if (arr[i].includes("sort="))
                    filters.sort = arr[i].split("=")[1];

                if (arr[i].includes("search="))
                    filters.patientName = arr[i].split("=")[1].toString();

                if (arr[i].includes("patientencounterbillingstatus="))
                    filters.encounterBillingStatus = arr[i]
                        .split("=")[1]
                        .toString();

                if (arr[i].includes("patientencounterstatus="))
                    filters.encounterStatus = arr[i].split("=")[1].toString();

                if (arr[i].includes("includearchived="))
                    filters.includeArchived = arr[i].split("=")[1] === "1";

                 if (arr[i].includes("badDebtor="))
                        filters.badDebtor = Number(arr[i].split("=")[1]);
                    else filters.badDebtor = Number(-1);

                if (arr[i].includes("dob=")) {
                    filters.dateOfBirth = arr[i].split("=")[1];
                    setTimeout(() => {
                        if (refreshDateInputValue) refreshDateInputValue();
                    }, 100);
                }

                if (arr[i].includes("doctorId=")) {
                    if (isNaN(arr[i].split("=")[1])) {
                        filters.doctorId = arr[i].split("=")[1];
                        selectedDoctors = filters.doctorId
                            .split(",")
                            .map((id) => Number(id));
                    } else {
                        filters.doctorId = Number(arr[i].split("=")[1]);
                        selectedDoctors = [Number(filters.doctorId)];
                    }
                }
            }
            updateURL();
        }
    };

    const updateCheckboxByQuery = (query) => {
        const arr = query.split("&");
        if (arr.length) {
            for (let i = 0; i < arr.length; i++) {
                if (arr[i].includes("check=")) {
                    const checkArr = arr[i].split("=")[1].split(",");
                    checkArr.map((ca) => {
                        if (!selectedPatients.some((p) => p.id == Number(ca))) {
                            let newPatientItem = { id: Number(ca) };
                            selectedPatients = [
                                ...selectedPatients,
                                newPatientItem,
                            ];
                            const checkbox = document.getElementById(
                                `selectCheckBoxId${ca}`,
                            );
                            if (checkbox) checkbox.checked = true;
                        }
                    });
                }
            }
        }
    };

    const loadPatients = (start, limit, params) => {
        isGettingPatients = true;
        if (params.sort) params.sort = params.sort.toLowerCase();

        apiMethods.getMethod
            .getPatient(start, limit, params)
            .then((res) => _handlePatients(res))
            .then(() => _updateHeaderSortIcon());
    };

    const handleFilterSelect = () => {
        page = 0;
        selectedPatients = [];

        updateURL();

        loadPatients(0, pageSize, _getSearchParams());

        setTimeout(() => {
            if (refreshDateInputValue) refreshDateInputValue();
        }, 100);
    };

    const handleSelectDoctor = () => {
        filters.doctorId = selectedDoctors.join(",");
        handleFilterSelect();
    };

    const generateSelectAll = () => {
        const selectAllHeader = document.getElementsByClassName(
            "toggleSelectAllHeader",
        )[0];
        const tag = document.createElement("input");
        tag.type = "checkbox";
        tag.className =
            "toggleSelectAll text-center hover:cursor-pointer checkbox checkbox-primary checkbox-xs bg-white ml-3 mt-2";
        tag.id = "toggleSelectAll";
        tag.onclick = () => {
            toggleSelectAll();
        };
        if (selectAllHeader) selectAllHeader.appendChild(tag);
    };

    const toggleSelectAll = () => {
        const selectAllCheckBox = document.getElementById("toggleSelectAll");
        if (selectAllCheckBox.className.includes("selectedAll")) {
            selectedPatients = [];
            _updateCheckBox();
        } else {
            returnPatientArr.forEach((patient) => {
                if (!selectedPatientsIdArr.includes(patient.id)) {
                    _addSelectedPatient(patient);
                }
            });
        }
    };

    const handleClickCell = ({ target: { className } }, rowData, key) => {
        if (key == "selected?") _addSelectedPatient(rowData);
        else goToURL(`/Patient/view/${rowData.id}`);
    };

    const handleClickCol = ({ target: { className } }, colData, key) => {
        if (key == "selected?") _updateCheckBox();
        else if (sortableHeaderKeys.includes(key)) {
            if (filters.sort == key) filters.sort = `${key}Desc`;
            else filters.sort = key;
            updateURL();
            loadPatients(0, pageSize, _getSearchParams());
        }
    };

    const onPageChange = (e) => {
        page = Number(e.detail.page);

        updateURL();

        loadPatients(
            Number(e.detail.firstDataIndex),
            pageSize,
            _getSearchParams(),
        );
        _updateCheckBox();
    };

    const onPageSizeChange = (newPageSize) => {
        pageSize = newPageSize;
        page = 0;

        updateURL();

        loadPatients(0, newPageSize, _getSearchParams());
    };

    const updateURL = () => {
        if (checkboxString)
            replaceURL(
                `/Patient/page=${page}&size=${pageSize}&check=${checkboxString}${_getParamsString()}`,
            );
        else
            replaceURL(
                `/Patient/page=${page}&size=${pageSize}${_getParamsString()}`,
            );
    };

    // HELPER FUNCTIONS
    const _handlePatients = (res) => {
        isGettingPatients = false;
        if (res.error) showError(res.error);
        else {
            returnPatientArr = [...res.results];
            count = res.total;
        }
        setTimeout(() => {
            generateSelectAll();
            _updateCheckBox();
        }, 1);
    };

    const _updateHeaderIcon = () => {
        const headerIcon = document.getElementById("toggleSelectAll");
        if (!headerIcon) return;
        if (selectedPatients.length === 0) {
            headerIcon.className =
                "toggleSelectAll text-center hover:cursor-pointer checkbox checkbox-primary checkbox-xs bg-white mt-2 ml-3 selectedNone";
            headerIcon.checked = false;
            headerIcon.style = "";
        } else if (
            returnPatientArr.every((patient) =>
                selectedPatientsIdArr.includes(patient.id),
            )
        ) {
            headerIcon.style.cssText = "";
            headerIcon.className =
                "toggleSelectAll text-center hover:cursor-pointer checkbox checkbox-primary checkbox-xs bg-white mt-2 ml-3 selectedAll";
            headerIcon.checked = true;
        } else {
            headerIcon.className =
                "toggleSelectAll text-center hover:cursor-pointer checkbox checkbox-primary checkbox-xs bg-white mt-2 ml-3 appearance-none selectedPartial";
            headerIcon.checked = false;
            headerIcon.style.cssText =
                "border: solid #270053; border-width: 4px; padding: 4px; border-radius: 5px; background-color: white; cursor: pointer; margin: 0.5rem 0 0 0.75rem";
        }
    };

    const _addSelectedPatient = (data) => {
        if (selectedPatients.some((patient) => patient.id === data.id)) {
            selectedPatients = selectedPatients.filter(
                (patient) => patient.id !== data.id,
            );
        } else {
            selectedPatients = [...selectedPatients, data];
            const checkbox = document.getElementById(
                `selectCheckBoxId${data.id}`,
            );
            if (checkbox) checkbox.checked = true;
        }
    };

    const _updateCheckBox = () => {
        setTimeout(() => {
            returnPatientArr.forEach((patient) => {
                const checkbox = document.getElementById(
                    `selectCheckBoxId${patient.id}`,
                );
                if (checkbox) {
                    if (selectedPatientsIdArr.includes(patient.id)) {
                        document.getElementById(
                            `selectCheckBoxId${patient.id}`,
                        ).checked = true;
                    } else {
                        document.getElementById(
                            `selectCheckBoxId${patient.id}`,
                        ).checked = false;
                    }
                }
            });
            _updateHeaderIcon();
        }, 1);
    };

    const _getSearchParams = () => {
        let params = {};

        if (filters.sort) params.sort = filters.sort;

        if (filters.patientName) params.search = filters.patientName;

        if (filters.doctorId) params["filter[doctorId]"] = filters.doctorId;

        if (filters.includeArchived) params["filter[includearchived]"] = 1;

        if (filters.encounterBillingStatus || filters.encounterBillingStatus == Number(0))
            params["filter[patientencounterbillingstatus]"] =
                filters.encounterBillingStatus;

        if (filters.encounterStatus || filters.encounterStatus == Number(0))
            params["filter[patientencounterstatus]"] = filters.encounterStatus;

        if (filters.dateOfBirth)
            params["filter[dateOfBirth]"] = filters.dateOfBirth;

        if (!isNaN(filters.badDebtor) && Number(filters.badDebtor) >= 0)
            params["filter[badDebtor]"] = filters.badDebtor;

        return params;
    };

    const _getParamsString = () => {
        let str = "";
        const params = _getSearchParams();

        if (params) {
            if (params.sort) str += `&sort=${params.sort}`;

            if (params.search) str += `&search=${params.search}`;

            if (params["filter[doctorId]"])
                str += `&doctorId=${params["filter[doctorId]"]}`;

            if (params["filter[patientencounterbillingstatus]"] ||
                    params["filter[patientencounterbillingstatus]"] == Number(0))
                str += `&patientencounterbillingstatus=${params["filter[patientencounterbillingstatus]"]}`;

            if (params["filter[patientencounterstatus]"] ||
                    params["filter[patientencounterstatus]"] == Number(0))
                str += `&patientencounterstatus=${params["filter[patientencounterstatus]"]}`;

            if (params["filter[includearchived]"])
                str += `&includearchived=${params["filter[includearchived]"]}`;

            if (params["filter[dateOfBirth]"])
                str += `&dob=${params["filter[dateOfBirth]"]}`;

             if (
                !isNaN(params["filter[badDebtor]"]) &&
                Number(params["filter[badDebtor]"]) >= 0
            )
                str += `&badDebtor=${params["filter[badDebtor]"]}`;
        }

        return encodeSearchParams(str);
    };

    const _getCheckboxString = (arr) => {
        if (arr.length) checkboxString = arr.toString();
        else checkboxString = "";

        updateURL();
    };

    const _updateHeaderSortIcon = () => {
        let thRow = document.getElementsByTagName("th");
        const params = _getSearchParams();

        if (params) {
            setTimeout(() => {
                const upSpan = document.createElement("span");
                const downSpan = document.createElement("span");
                upSpan.innerHTML = `<i class="fas fa-sort-alpha-down" />`;
                upSpan.style = "font-size: 10px;";
                downSpan.innerHTML = `<i class="fas fa-sort-alpha-up-alt" />`;
                downSpan.style = "font-size: 10px;";

                Array.from(thRow).forEach((row) => {
                    if (
                        (params.sort == "id" &&
                            row.childNodes[0].data == "Patient ID") ||
                        (params.sort == "name" &&
                            row.childNodes[0].data == "Patient name")
                    )
                        row.appendChild(upSpan);
                    else if (
                        (params.sort == "idDesc" &&
                            row.childNodes[0].data == "Patient ID") ||
                        (params.sort == "nameDesc" &&
                            row.childNodes[0].data == "Patient name")
                    )
                        row.appendChild(downSpan);
                });
            }, 0);
        }
    };

    const _getName = ({ firstName, lastName, title, middleName }) => {
        const name = `${firstName}${
            middleName ? " " + middleName : ""
        } ${lastName}`;

        return `${getTitle(title)} ${name}`;
    };

    const _getGender = (gender) => {
        switch (gender) {
            case 0:
                return "Male";
            case 1:
                return "Female";
            case 2:
                return "Not Specified";
            case 3:
                return "Unknown";
            default:
                return "Unknown";
        }
    };

    const toggleFilters = () => {
        showFilters = !showFilters;
    };

    const filterTransition = (node, args) => ($isMobile ? fly(node, args) : "");
</script>

<div class="flex flex-col flex-1 gap-y-4">
    {#if $isMobile}
        <button
            class="btn btn-accent btn-sm w-28 flex flex-row gap-x-3"
            on:click={toggleFilters}
        >
            Filters
            <i
                style="font-size:20px"
                class={showFilters ? "fa arrow-up" : "fa arrow-down"}
                >&#xf104;
            </i>
        </button>
    {/if}
    {#if showFilters || !$isMobile}
        <div
            class="flex flex-0 items-start {$isMobile
                ? 'flex-col gap-y-4'
                : 'justify-between'}"
            in:filterTransition={{ duration: 200, y: -100 }}
        >
            <div
                class="flex flex-row gap-4 items-end justify-between flex-wrap"
            >
                <SearchInput
                    bind:value={filters.patientName}
                    title="Search or Patient ID"
                    inputFunc={handleFilterSelect}
                    info="You may also search by medicare number or health fund membership number"
                    isLong
                />

                <DoctorMultiSearchSelect
                    bind:searchResult={selectedDoctors}
                    onChangeFunc={handleSelectDoctor}
                    inputClass="w-32 "
                    zIndex="100"
                />

                <SearchInput
                    bind:value={filters.dateOfBirth}
                    title="Date of Birth"
                    type="date"
                    inputClass="borderB"
                    inputFunc={handleFilterSelect}
                    isLong
                    maxDate={new Date()}
                    isDisable={isGettingPatients}
                    bind:refreshDateInputValue
                />

                <SearchSelect
                    bind:value={filters.encounterBillingStatus}
                    title="Encounter Billing Status"
                    onChangeFunc={handleFilterSelect}
                    isLong
                >
                    <option value="all">All Statuses</option>
                    <option value="0,1,2,3,4" selected>
                        All Except Completed
                    </option>
                    {#each BillingStatus as billingStatusItem}
                        <option value={billingStatusItem.id}>
                            {billingStatusItem.type}
                        </option>
                    {/each}
                </SearchSelect>

                <SearchSelect
                    bind:value={filters.encounterStatus}
                    title="Encounter Status"
                    onChangeFunc={handleFilterSelect}
                    isLong
                >
                    {#each encounterStatus as { id, type }}
                        <option value={id.toString()}>{type}</option>
                    {/each}
                </SearchSelect>

                <SearchSelect
                    bind:value={filters.badDebtor}
                    title="Bad Debtor"
                    onChangeFunc={handleFilterSelect}
                    isDisabled={isGettingPatients}
                    inputClass=""
                >
                    <option value={Number(-1)} selected>All</option>
                    <option value={Number(0)}>Non-Bad Debtors</option>
                    <option value={Number(1)}> Bad Debtors </option>
                </SearchSelect>

                <div class="flex flex-row items-center gap-x-[6px]">
                    <input
                        type="checkbox"
                        class="toggle toggle-secondary"
                        bind:checked={filters.includeArchived}
                        id="includeArchived"
                        on:change={handleFilterSelect}
                        disabled={isGettingPatients}
                    />
                    <label for="includeArchived">Include archived</label>
                </div>

                <ResetFilterLink
                    bind:filter={filters}
                    onResetFilter={() => {
                        filters = {
                            includeArchived: false,
                            encounterBillingStatus: "0,1,2,3,4",
                            encounterStatus: "0",
                            badDebtor: Number(-1),
                        };
                        selectedDoctors = [];
                        handleFilterSelect();
                    }}
                />
            </div>
        </div>
    {/if}

    <div class={$isMobile ? "h-auto w-minus48" : "relative flex-1"}>
        {#if isGettingPatients}
            <PageLoading />
        {:else}
            <div
                class={$isMobile
                    ? "overflow-x-scroll overflow-y-visible"
                    : "overflow-y-auto absolute inset-0"}
            >
                <SvelteTable
                    {columns}
                    rows={returnPatientArr}
                    clickCellFunc={({ detail: { event, row, key } }) => {
                        handleClickCell(event, row, key);
                    }}
                    clickColFunc={({ detail: { event, row, key } }) => {
                        handleClickCol(event, row, key);
                    }}
                />
            </div>
        {/if}
    </div>

    <TableFooter
        {page}
        {pageSize}
        {count}
        showSelected
        selectedCount={selectedPatients.length}
        tableData={returnPatientArr}
        {onPageChange}
        {onPageSizeChange}
        csvConfig={{
            columns,
            data: returnPatientArr,
            fileName: "Patient",
            allDataApi: async () =>
                await apiMethods.getMethod.getPatient(
                    0,
                    999999,
                    _getSearchParams(),
                ),
        }}
    />
</div>
